import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Mic } from 'lucide-react';
import { VoiceMicPopup } from '@/components/VoiceMicPopup';

const HIDDEN_ROUTES = ['/', '/onboarding', '/admin', '/voice'];

export default function GlobalMicButton() {
  const location = useLocation();
  const [showVoice, setShowVoice] = useState(false);

  if (HIDDEN_ROUTES.includes(location.pathname)) return null;

  return (
    <>
      {/* Floating Mic Button — LEFT side, above navbar, above footer z-index */}
      <button
        data-testid="global-mic-btn"
        onClick={() => setShowVoice(true)}
        aria-label="Voice input"
        style={{
          position: 'fixed',
          bottom: 100,
          left: 16,
          zIndex: 110,
          width: 52,
          height: 52,
          borderRadius: '50%',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(135deg, #5A8C6A 0%, #C67A5C 50%, #E5A84B 80%, #9B59B6 100%)',
          boxShadow: '0 4px 16px rgba(90,140,106,0.3), 0 2px 6px rgba(0,0,0,0.1)',
          transition: 'transform 0.15s ease, box-shadow 0.15s ease',
        }}
        onMouseDown={e => { e.currentTarget.style.transform = 'scale(0.9)'; }}
        onMouseUp={e => { e.currentTarget.style.transform = 'scale(1)'; }}
        onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; }}
      >
        <Mic style={{ width: 22, height: 22, color: '#FFF', filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.2))' }} />
      </button>

      {/* Voice popup — pass open prop so it actually opens */}
      <VoiceMicPopup open={showVoice} onClose={() => setShowVoice(false)} />
    </>
  );
}
